import moment from "moment";

export function character_limiter(str, num, sep) {
    return _.truncate(str, {
        'length': num,
        'separator': sep
    });
}


export function inArray(needle, haystack) {
    var length = haystack.length;
    for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
    }
    return false;
}

export function getElementIdWidth(id) {
    return document.getElementById(id).clientWidth;
}

export function zeroFill(number, width) {
    width -= number.toString().length;
    if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
    }
    return number + ""; // always return a string
}

/*
export function slugify(string) {
    const a = 'àáäâãåèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;'
    const b = 'aaaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------'
    const p = new RegExp(a.split('').join('|'), 'g')

    return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with ‘and’
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple — with single -
        .replace(/^-+/, '') // Trim — from start of text .replace(/-+$/, '') // Trim — from end of text
}
*/

export function slugify(string) {
    //return _.kebabCase(string.replace(/&/g,'-and-')); // This will replace the "&" with -and-
    return _.kebabCase(string);
}


export function stringToBoolean(string) {
    switch (string.toLowerCase().trim()) {
        case true:
        case "true":
        case "yes":
        case "1":
            return true;
        case false:
        case "false":
        case "no":
        case "0":
        case null:
            return false;
        default:
            return Boolean(string);
    }
}


/** 
 * * ++++++++++++++++++++++++++++++++++++++++++++
 * * ++++++++++++++++++++++++++++++++++++++++++++
 * ! FUNCTION FOR TIME AND DATE MANIPULATION
 * * ++++++++++++++++++++++++++++++++++++++++++++
 * * +++++++++++++++++++++++++++++++++++++++++++
 */
export function echoTime(time) {
    return moment(time, 'HH:mm').format('HH:mm');
}

export function echoTimeWithSec(time) {
    return moment(time, 'HH:mm:ss').format('HH:mm');
}

export function minutesToTime(minutes) {
    let h = Math.floor(minutes / 60);
    let m = minutes % 60;
    if (h < 10) h = '0' + h.toString();
    if (m < 10) m = '0' + m.toString();
    return h + ':' + m;
}

/**
 * 
 * @param {string} time In format hh:mm:ss
 * @returns {string} in format : 43h35
 */
export function echoDuration(time) {
    let timeSplit = time.split(':');
    return timeSplit[0] + 'h' + timeSplit[0];

    // out
}

/**
 * 
 * @param {string} myDate In format YYYY-MM-DD
 * @returns {string} in format : Lun. 14/03/19
 */
export function echoDateWithDay(myDate) {
    return moment(
        myDate,
        "YYYY-MM-DD"
    ).format(
        'ddd D/MM/YY '
    );
}

/**
 * 
 * @param {string} myDate In format YYYY-MM-DD
 * @returns {string} in format : Lunes (14 mar.)
 */
export function echoDateParenthesis(mydate) {
    return moment(
        mydate,
        "YYYY-MM-DD"
    ).format("dddd (DD MMM)");
}

/**
 * 
 * @param {string} myDate In format YYYY-MM-DD
 * @returns {string} in format : 14 mar
 */
export function echoDateShort(mydate) {
    return moment(
        mydate,
        "YYYY-MM-DD"
    ).format("DD MMM");
}

/**
 * Display time elapsed between 2 dates
 * @param {string} datetime1 In format YYYY-MM-DD HH:mm:ss
 * @param {string} datetime2 In format YYYY-MM-DD HH:mm:ss
 * @returns {string} in format : 3h55
 */
export function timeDiff(datetime1, datetime2) {
    const ms = moment(datetime1, "YYYY-MM-DD HH:mm:ss").diff(moment(datetime2, "YYYY-MM-DD HH:mm:ss"));
    const d = moment.duration(ms);
    const s = Math.floor(d.asHours()) + 'h' + moment.utc(ms).format("mm");
    return s;
    // out
}
/**
 * Display time elapsed between 2 dates
 * @param {int} datetime1 In miunutes
 * @param {int} datetime2 In minutes
 * @returns {string} in format : 3h55
 */
export function timeDiffFromMinutes(datetime1, datetime2) {
    let diffMinutes = datetime2 - datetime1;
    return minutesToTime(diffMinutes);
}


/**
 * Format money string anount according to locale
 * @param {string} number:  the amount to format
 * @returns {string} ex: 143,50€
 */
export function money(number) {
    if (typeof number != 'undefined' && number !== null) {
        let symbol = '€';
        let dec_point = ",";
        let thousands_sep = ".";
        let is_symbol_before_amount = 0;
        number = number_format(number, 2, dec_point, thousands_sep);
        number = number.replace(dec_point + '00', '');
        if (is_symbol_before_amount == 1)
            return symbol + number;
        else return number + symbol;
    }
    else return null;
}

/**
 * Format money string anount according to locale
 * @param {string} number:  the amount to format
 * @returns {string} ex: 143,50€
 */
export function moneyCents(number) {
    if (number !== null) {
        let symbol = 'cént.';
        let dec_point = ",";
        let thousands_sep = ".";
        let is_symbol_before_amount = 0;
        number = number_format(number, 2, dec_point, thousands_sep);
        number = number.replace(dec_point + '00', '');
        if (is_symbol_before_amount == 1)
            return symbol + number;
        else return number + symbol;
    }
    else return null;
}

/**
 * number_format PHP function in javascript
 * @param {string} number
 * @param {string} decimals:  number of decimal
 * @param {string} dec_point:  deciaml separator
 * @param {string} thousands_point:  thousand separator
 * @returns {string}
 */
export function number_format(number, decimals, dec_point, thousands_point) {

    if (number == null || !isFinite(number)) {
        throw new TypeError("number is not valid");
    }

    if (!decimals) {
        var len = number.toString().split('.').length;
        decimals = len > 1 ? len : 0;
    }

    if (!dec_point) {
        dec_point = '.';
    }

    if (!thousands_point) {
        thousands_point = ',';
    }

    number = parseFloat(number).toFixed(decimals);

    number = number.replace(".", dec_point);

    var splitNum = number.split(dec_point);
    splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_point);
    number = splitNum.join(dec_point);

    return number;
}

/**
 * Convert time (hh:mm:ss) into minutes 
 * @param {string} time : 14:30:00
 * @returns int
 */
export function convertTimeToMinutes(time) {
    let ex = time.split(":");
    return parseInt(ex[0]) * 60 + parseInt(ex[1]);
};


/**
 * Convert number (between 0 and 1440) to hh:mm
 * @param {number} value 
 * @return string => hh:mm
 */
export function int2time(value) {
    var h = Math.floor(value / 60);
    var m = Math.floor(value % 60);
    h = h < 10 ? "0" + h : h;
    m = m < 10 ? "0" + m : m;
    return h + ":" + m;
};


/**
 * Round and add "H" for hours to float number
 * @param {float} value 
 */
export function format4Duration(value) {
    return _.round(value, 1) + 'h';
};



export function addslashes(str) {
    return (str + '').replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0');
}
/*
“Count where” in a collection
-------------------------------
var b = _.filter(a, function(o) { if (o.a < 4) return o }).length;

Get Unique
------------
_.uniq(books, function(book) { return book.id; })
*/


/**
 * Remove the brand name of a string llike follow : 
 * Movistar - bla bla bla bla => to just => bla bla bla bla
 * @param {string} str 
 */
export function removeBrand(str) {
    let strSplit = str.split('-');
    if (strSplit.length > 1)
        return _.trimStart(strSplit[1]);
    else return str;
}

/**
 * One line function to detect mobile devices with JavaScript
 * However you must take into account that maybe it's not 100% reliable and some devices could give you "false" 
 */
export function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};



export function imageExists(image_url) {

    var http = new XMLHttpRequest();

    http.open('HEAD', image_url, false);
    http.send();

    return http.status != 404;

};

export function getAvailabilityText($type) {

    switch ($type) {
        case "in_stock":
            return 'En stock';
            break;
        case "not_in_stock":
            return 'Sin stock';
            break;
        default:
            return '';
            break;
    }
}

export function multiIncludes(text, values) {
    var re = new RegExp(values.join('|'));
    return re.test(text);
}

export function getDeviceLabels(deviceType) {
    const data = new Object();
    switch (deviceType) {
        case 'Smartphone':
            data.folder = 'dispositivos';
            data.label = 'móviles';
            data.imgFolder = 'devices';
            data.imgExt = '.jpg';
            break;
        case 'Smartwatch':
            data.folder = 'smartwatches';
            data.label = 'smartwatches';
            data.imgFolder = 'smartwatches';
            data.imgExt = '_0.webp';
            break
        case 'Mediaplayer':
            data.folder = 'reproductores-multimedia';
            data.label = 'reproductores multimedia';
            data.imgFolder = 'mediaplayers';
            data.imgExt = '_0.webp';
            break;
        case 'Headphone':
            data.folder = 'auriculares';
            data.label = 'auriculares';
            data.imgFolder = 'headphones';
            data.imgExt = '_0-md.webp';
            break;
        default:
            data.folder = 'dispositivos';
            data.label = 'dispositivos';
            data.imgFolder = 'devices';
            data.imgExt = '.jpg';
            break;
    }
    return data;
}



// export function formatMoneyHtml(amount, classStyle = "mb-3", center = false){
//     let whole = parseInt(amount);
//     let fraction = _.round(amount - whole, 2) * 100;
//     if(fraction < 10 )
//       fraction = '0' + String(parseInt(fraction));
//     else fraction = String(fraction);

//     return (
//         <div class=={`priceStyle ${classStyle} ${((center) ? "justify-content-center" : "")} `}>
//             <strong class="amount">{whole}</strong>
//             <div class="price-extra text-left">
//                 <strong>'{fraction}</strong><span>€/mes</span>';
//             </div>
//         </div>
//     );
// }

export function formatMoneyHtml(amount, classStyle = 'fslhb-4', center = false, pricePerMonth = true, from = true) {
    let whole = '__';
    let fraction = '__';
    if (isNaN(amount) == false && amount !== null) {
        whole = Math.trunc(amount);
        fraction = Math.round((amount - whole) * 100);
        if (fraction < 10) fraction = '0' + fraction;
        else fraction = fraction.toString();
    }
    else {
        classStyle += ' text-opacity-25';
    }

    let paddingClass = 'pb-1';
    if (classStyle !== 'fslhb-4') {
        //paddingClass = '';
    }

    let html = '<div>';
    if (from) {
        html += '    <div class="desde p-0 m-0"><small>desde</small></div>';
    }
    html += `    <div class="price d-flex justify-content-${(center ? "center" : "start")}">`;
    html += `        <div class="${classStyle}">${whole}</div>`;
    html += `        <div class="d-flex flex-column justify-content-between pb-1">`;
    html += `            <div class="${classStyle == 'fslhb-4' ? 'pt-1' : ''} text-start">,${fraction}</div>`;
    if (pricePerMonth) {
        html += `            <div class="small text-start ${paddingClass}">€/mes</div>`;
    } else {
        html += `            <div class="small text-start ${paddingClass}">€</div>`;
    }
    html += `        </div>`;
    html += `    </div>`;
    html += `</div>`;

    return html;
}

export function getScoreCalification(score) {
    score = Math.floor(score);
    if (score == 0 || _.isNull(score)) {
        return 'x';
    } else if (score <= 49) {
        return 'f';
    } else if (score >= 50 && score <= 59) {
        return 'e';
    } else if (score >= 60 && score <= 69) {
        return 'd';
    } else if (score >= 70 && score <= 79) {
        return 'c';
    } else if (score >= 80 && score <= 89) {
        return 'b';
    } else if (score >= 90) {
        return 'a';
    }
}

export function stringToColorCode(str) {
    let code = (crc32(str) >>> 0).toString(16);
    code = code.slice(0, 6).toUpperCase();
    return code;
}

function crc32(str) {
    const crcTable = makeCrcTable();
    let crc = 0 ^ (-1);

    for (let i = 0; i < str.length; i++) {
        const charCode = str.charCodeAt(i);
        crc = (crc >>> 8) ^ crcTable[(crc ^ charCode) & 0xFF];
    }

    return (crc ^ (-1)) >>> 0;
}

function makeCrcTable() {
    const crcTable = [];
    for (let n = 0; n < 256; n++) {
        let c = n;
        for (let k = 0; k < 8; k++) {
            if (c & 1) {
                c = 0xEDB88320 ^ (c >>> 1);
            } else {
                c = c >>> 1;
            }
        }
        crcTable[n] = c;
    }
    return crcTable;
}


export function bestTextColor(hexCode) {
    let redHex = hexCode.substr(0, 2);
    let greenHex = hexCode.substr(2, 2);
    let blueHex = hexCode.substr(4, 2);

    let r = parseInt(redHex, 16) / 255;
    let g = parseInt(greenHex, 16) / 255;
    let b = parseInt(blueHex, 16) / 255;

    let brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    // human eye sees 60% easier
    if (brightness > 0.6) {
        return '000000';
    } else {
        return 'ffffff';
    }
}

export function getRepairabilityClass(repairability_index = null) {
    if (repairability_index === null) {
        return 'default';
    }

    let repairClass;

    switch (true) {
        case repairability_index < 2:
            repairClass = 0;
            break;
        case repairability_index < 4:
            repairClass = 2;
            break;
        case repairability_index < 6:
            repairClass = 4;
            break;
        case repairability_index < 8:
            repairClass = 6;
            break;
        case repairability_index <= 10:
            repairClass = 8;
            break;
        default:
            repairClass = 'default';
            break;
    }

    return repairClass;
}

// export function getNextAndPrevIds(deviceIds, id){
//     let nextId = null;
//     let prevId = null;
//     if(deviceIds.length > 0) {
//         const index = deviceIds.indexOf(id);
//         if (index === -1) {
//             return null; // Return null if the id is not found
//         }
//         nextId = index === deviceIds.length - 1 ? null : deviceIds[index + 1];
//         prevId = index === 0 ? null : deviceIds[index - 1];
//     }
//     return { prevId, nextId };
// }

export function getNextAndPrevIds(array, id) {

    let nextId = null;
    let prevId = null;
    if (typeof array !== 'undefined' && array.length > 0) {
        const index = array.findIndex(obj => obj.id === id);
        // console.log('getNextAndPrevIds', index);
        if (index !== -1) {
            const previousIndex = index - 1;
            const nextIndex = index + 1;

            prevId = previousIndex >= 0 ? array[previousIndex].id : null;
            nextId = nextIndex < array.length ? array[nextIndex].id : null;

        }
    }
    return { prevId, nextId };
}





export function removeWordsAtBeginning(inputString, wordsToRemove) {
    if (inputString.length > 0 && _.words(inputString).length > 1) {
        // Convert the words to remove to an array of regular expressions
        const patterns = _.map(wordsToRemove, (word) => {
            return new RegExp('^' + _.escapeRegExp(word), 'i');
        });

        // Split the input string into an array of words
        const words = _.words(inputString);

        // Remove the words to remove from the beginning of the array
        _.forEach(patterns, (pattern) => {
            if (pattern.test(words[0])) {
                words.shift();
            }
        });

        // Convert the array back to a string
        const outputString = words.join(' ');

        // Return the output string
        return outputString;
    }
    return '';
};

export function countDifferences(obj1, obj2) {
    let differences = 0;
    const allKeys = _.union(_.keys(obj1), _.keys(obj2));

    allKeys.forEach(key => {
        if (!_.isEqual(obj1[key], obj2[key])) {
            differences++;
        }
    });

    return differences;
};

